import React from "react";
import PageContent from "../components/PageContent";

export default function PrivacyPolicyPage() {
    return (
        <PageContent
            internalId="privacy_policy"
            fallbackTitle="Политика конфиденциальности"
            fallbackContent=""
        />
    );
}
